import React from 'react';
import { Link } from 'react-router-dom';
import { LINKS } from '../constants/links';

interface FooterProps {
  isDark: boolean;
}

export default function Footer({ isDark }: FooterProps) {
  const logoSrc = isDark
    ? '/assets/norlab_logo_acronym_light-2.webp'
    : '/assets/norlab_logo_acronym_dark.webp';

  return (
    <footer className="bg-gray-100 dark:bg-darkbg py-6 z-20">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-6 md:space-y-0">
        <div className="flex flex-row justify-center gap-6 md:hidden">
          <a href="https://norlab.ulaval.ca/">
            <div className="h-[60px] w-[180px] flex items-center justify-center">
              <img
                src={logoSrc}
                alt="Norlab Logo"
                className={isDark ? 'h-[59px]' : 'h-[48px]'}
              />
            </div>
          </a>
          <a href="http://asrl.utias.utoronto.ca/">
            <img
              src="/assets/asrl.webp"
              alt="ASRL Logo"
              width={150}
              height={96}
            />
          </a>
        </div>

        <a href="https://norlab.ulaval.ca/" className="hidden md:block">
          <div className="h-[60px] w-[180px] flex items-center justify-center mx-auto md:mx-0">
            <img
              src={logoSrc}
              alt="Norlab Logo"
              className={isDark ? 'h-[59px]' : 'h-[48px]'}
            />
          </div>
        </a>

        <div className="text-sm text-center text-gray-600 dark:text-gray-300 max-w-xl space-y-3">
          {/*
          <p>
            You can view the{' '}
            <a
              className="underline"
              href="https://github.com/norlab-ulaval/FoMo-website"
            >
              source code on GitHub
            </a>
            .
          </p>
          */}
          <Link
            to="/contact#contact"
            className="inline-block bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition"
          >
            Contact Us
          </Link>
          <p className="text-sm text-gray-500">
            <a
              href="https://www.linkedin.com/in/gabriel-roland-caverivière-75378b2aa"
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-blue-600 hover:text-blue-700"
            >
              Gabriel Roland-Caverivière
            </a>
            {' | 2025 Northern Robotics Laboratory | '}
            <Link
              to={LINKS.LICENSE}
              className="underline text-blue-600 hover:text-blue-700"
            >
              MIT License
            </Link>
          </p>
        </div>

        <a href="http://asrl.utias.utoronto.ca/" className="hidden md:block">
          <div className="h-[60px] w-[200px] flex items-center justify-center mx-auto md:mx-0">
            <img src="/assets/asrl.webp" alt="ASRL Logo" className="h-24" />
          </div>
        </a>
      </div>
    </footer>
  );
}
